<template>
    <section>
        <div>
          <h1>Saindo...</h1>
          <small>Obrigado!</small>
        </div>
    </section>
</template>

<script>
export default {
  mounted: function () {
    // O setTimeout tem a finalizada de deixar exibir a animação ao fazer o logout.
    setTimeout(() => {
      let sessaoUsuario = []
      this.$store.commit('setLoginUsuario', sessaoUsuario)
      localStorage.clear()
      // this.$router.push('/')
      document.location.href = '/'
    }, 2000)
  }
}
</script>


<style scoped>
  section {
    color: #FFF;
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-color: #222d32;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 1s;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// Logout.vue?53bc6034